import moment from 'moment';
import _ from 'lodash';

export const validateDate = (rule, value, callback) => {
  if (!moment(value).isValid()) {
    callback('The date you entered is not valid');
  } else {
    callback();
  }
};

export const validatePhone = (rule, value, callback) => {
  const placeholder = '(___) ___-____';
  if (!_.isEmpty(value) && value.includes('_') && value !== placeholder && value.match(/\d/) !== null) {
    callback('The phone you entered is not valid');
  } else {
    callback();
  }
};

export const validateUsername = (rule, value, callback) => {
  if (!value.match(/^[a-zA-Z0-9](\w|\.|-)*[a-zA-Z0-9]$/)) {
    callback('Username cannot contain spaces. Only symbols allowed are dashes, underscores, and periods. May not start or end with symbols.');
  } else if (value.length < 4 || value.length > 36) {
    callback('Username must be between 4 to 36 characters.');
  } else {
    callback();
  }
};
